import {
  take,
  takeEvery,
  put,
  call,
  fork,
  all,
  cancel,
  getContext,
  select,
} from 'redux-saga/effects';
import { actions as appActions, HIDE_AUTH_MODAL } from '../../actions/app';
import { actions, ACTIVATE, DEACTIVATE, FINISH, GO_TO_STEP } from './actions';
import selector from './selectors';
import personalData from './components/PersonalDataForm/sagas';
import verification from './components/VerificationForm/sagas';
import loginAndPassword from './components/LoginAndPasswordForm/sagas';
import { SagaContext } from '../../types/common';
import * as gtmDataLayer from '../../utils/gtmDataLayer';
import { lifecycle } from './actions';
import { Services } from 'init/services';
import { languageSelector } from '../../selectors/app';
import { PRODUCT } from '../../consts';

function* loginSaga() {
  const keycloakService: Services[SagaContext.KeycloakService] = yield getContext(
    SagaContext.KeycloakService
  );
  const { login, password }: ReturnType<typeof selector> = yield select(selector);
  const locale: ReturnType<typeof languageSelector> = yield select(languageSelector);

  yield call(() => keycloakService.authorizeByFirstFactor(login, password, PRODUCT, locale));

  yield put(actions.reset());
  yield put(appActions.login({ isFirst: true }));
  yield put(lifecycle.deactivate());
}

type ActivateAction = ReturnType<typeof lifecycle.activate>;

type GoToStepAction = ReturnType<typeof actions.goToStep>;

export default function* saga() {
  while (true) {
    const {
      payload: { source },
    }: ActivateAction = yield take(ACTIVATE);

    yield takeEvery(GO_TO_STEP, function* ({ payload: { step } }: GoToStepAction) {
      if (step === 'PERSONAL_DATA') {
        yield put(actions.resetSessionId());
      }
    });

    yield takeEvery(FINISH, function* () {
      gtmDataLayer.push({
        eventCategory: 'form',
        eventAction: 'registration',
        eventLabel: source,
      });

      yield call(loginSaga);
    });

    yield put(actions.resetSessionId());

    // @ts-ignore
    const tasks = yield all([
      fork(personalData, actions.goToStep('VERIFIACTION')),
      fork(verification(actions.goToStep('LOGIN_AND_PASSWORD'))),
      fork(loginAndPassword, actions.finish()),
    ]);

    yield takeEvery(HIDE_AUTH_MODAL, function* () {
      yield put(lifecycle.deactivate());
    });

    yield take(DEACTIVATE);
    cancel([...tasks]);
  }
}
